import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppStoreService } from '../../../stores/app-store.service';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { LoadingOverlayComponent } from '@webapp/ui';
import { APP_VERSION } from '../../../config';

@Component({
  selector: 'app-dashboard-layout',
  standalone: true,
  imports: [NavbarComponent, RouterOutlet, LoadingOverlayComponent],
  templateUrl: './dashboard-layout.component.html',
  styleUrl: './dashboard-layout.component.scss',
})
export class DashboardLayoutComponent {
  private readonly appStateService = inject(AppStoreService);
  readonly appState = this.appStateService.state.asReadonly();
  readonly version = inject(APP_VERSION, { optional: true }) ?? '';
}
